<template>
  <div class="suggest-page-wrap">
    <!--筛选区域-->
    <div class="filter-bar">
      <el-select v-model="queryParam.status" placeholder="全部状态" clearable style="width:160px;margin-right:12px">
        <el-option label="全部状态" :value="null"></el-option>
        <el-option label="提交" :value="0"></el-option>
        <el-option label="处理中" :value="1"></el-option>
        <el-option label="处理完成" :value="10"></el-option>
        <el-option label="进入需求库" :value="99"></el-option>
      </el-select>
      <el-select v-model="queryParam.type" placeholder="全部类型" clearable style="width:160px;margin-right:12px">
        <el-option label="全部类型" :value="null"></el-option>
        <el-option label="功能建议" value="FUNCTION"></el-option>
        <el-option label="BUG反馈" value="BUG"></el-option>
        <el-option label="体验优化" value="OPTIMIZE"></el-option>
        <el-option label="其他" value="OTHER"></el-option>
      </el-select>
      <el-button type="primary" @click="loadMyList">查询</el-button>
      <el-button style="margin-left:auto" type="primary" @click="openAddDialog">新增反馈</el-button>
    </div>
    <!--我的反馈列表表格-->
    <el-table :data="tableData" border style="width:100%;margin-top:12px">
          <el-table-column label="标题" prop="name" align="center"/>
          <el-table-column label="类型" prop="type" width="100px" align="center">
            <template slot-scope="scope">
              {{ getTypeName(scope.row.type) }}
            </template>
          </el-table-column>
    	  <el-table-column label="反馈" prop="type">
    	    <template slot-scope="scope">
    	      {{ scope.row.feedbackText||'--'}}
    	    </template>
    	  </el-table-column>
          <el-table-column label="状态" prop="status" width="100px" align="center">
            <template slot-scope="scope">
              {{ getStatusName(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column label="提交时间" prop="submitTime" width="140px" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.submitTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px" align="center">
            <template slot-scope="scope">
              <el-button link type="text" @click="openViewDialog(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin-top:14px;text-align:right"
      :current-page="pageInfo.pageNum"
      :total="pageInfo.total"
      layout="total, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
    />
    <!--新增/查看详情 复用同一个弹窗-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="onDialogClose"  :z-Index="3999" :append-to-body="true">
      <div class="suggest-form-wrap">
        <div class="form-scroll-container">
          <el-form ref="formRef" :model="formData" :rules="formRules" label-width="100px" :disabled="isViewMode">
            <el-form-item label="名称" prop="name">
              <el-input v-model="formData.name" placeholder="请输入名称，最多30个字" maxlength="30" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="建议类型" prop="suggestType">
              <el-select v-model="formData.suggestType" placeholder="请选择建议类型">
                <el-option label="功能建议" value="FUNCTION"></el-option>
                <el-option label="BUG反馈" value="BUG"></el-option>
                <el-option label="体验优化" value="OPTIMIZE"></el-option>
                <el-option label="其他" value="OTHER"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容" prop="content">
              <el-input v-model="formData.content" type="textarea" :rows="6" placeholder="请输入建议内容（纯文本）"></el-input>
            </el-form-item>
            <el-form-item label="上传图片" >
              <el-upload
				v-if="!isViewMode"
                ref="uploadRef"
                :class="['avatar-uploader', pictureFile ? 'has-file' : '']"
                action="#"
                :show-file-list="true"
                :limit="1"
                list-type="picture-card"
                :auto-upload="false"
                :on-exceed="handleExceed"
                :on-change="handleFileChange"
                :on-remove="handleRemove"
                :disabled="isViewMode"
              >
                <i v-if="!pictureFile && !isViewMode" class="el-icon-plus"></i>
              </el-upload>
			  <el-image
			    v-else
			    :src="url"
			    :preview-src-list="[url]"
			    style="width:200px;height:auto;"
			  >
			  </el-image>
            </el-form-item>
			
          </el-form>
        </div>
        <div class="form-btn-wrap">
          <el-button v-if="!isViewMode" type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="handleCancel">{{ isViewMode ? '关闭' : '取消' }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadToOss } from "@/js/img.js"
export default {
  name: "MySuggestPage",
  data() {
    return {
      //列表筛选分页
      dialogVisible: false,
      dialogTitle:"新增反馈",
      isViewMode:false, // true=查看详情模式，false=新增模式
      queryParam: {
        status: null,
        type: null
      },
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      formData: {
        name: "",
        suggestType: "",
        content: "",
      },
	  url:'',
      pictureFile: null,
      formRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 30, message: "名称不能超过30个字", trigger: "blur" }
        ],
        suggestType: [
          { required: true, message: "请选择建议类型", trigger: "change" }
        ],
        content: [
          { required: true, message: "请输入建议内容", trigger: "blur" }
        ]
      },
      login: null
    };
  },
  mounted() {
    this.loadMyList()
  },
  methods: {
    //打开新增
    openAddDialog() {
		this.url=''
      this.isViewMode = false
      this.dialogTitle = "新增反馈"
      this.dialogVisible = true
    },
    //打开查看详情
    async openViewDialog(row){
	this.url=''
      this.isViewMode = true
      this.dialogTitle = row.name
      this.formData.name = row.name
      this.formData.suggestType = row.type
      this.formData.content = row.text
	  if(row.url){
		  this.url=await this.$oss.getDownloadUrl(row.url)
	  }
      this.pictureFile = null
      this.dialogVisible = true
    },
    onDialogClose() {
      this.resetFormInner()
    },
    async loadMyList() {
      try {
        let res = await this.API.get(this.API.fileurl.getSuggestMyPage, {
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          status: this.queryParam.status,
          type: this.queryParam.type
        })
        if (res.data.code === 200) {
          const pageVo = res.data.data
          this.tableData = pageVo.records
          this.pageInfo.total = pageVo.total
        }
      } catch (e) {
        this.$message.error("加载列表失败")
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.pageInfo.pageNum = 1
      this.loadMyList()
    },
    handlePageChange(val) {
      this.pageInfo.pageNum = val
      this.loadMyList()
    },
    getTypeName(val) {
      const map = {
        "FUNCTION": "功能建议",
        "BUG": "BUG反馈",
        "OPTIMIZE": "体验优化",
        "OTHER": "其他"
      }
      return map[val] || val
    },
    getStatusName(val) {
      const map = {
        0: "提交",
        1: "处理中",
        10: "处理完成",
        99: "进入需求库"
      }
      return map[val] || val
    },
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${(date.getMonth() + 1 + "").padStart(2, '0')}-${(date.getDate() + "").padStart(2, '0')} ${(date.getHours() + "").padStart(2, '0')}:${(date.getMinutes() + "").padStart(2, '0')}`
    },
    handleFileChange(file) {
      this.pictureFile = file.raw;
    },
    handleExceed() {
      this.$message.warning("仅支持上传1张图片");
    },
    handleRemove() {
      this.pictureFile = null;
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const pamt = {
          ...this.formData,
          pictureFile: this.pictureFile
        };
        
        this.submit(pamt)
      });
    },
    loginOpen(text) {
      this.login = this.$loading({
        lock: true,
        text,
        zIndex: 100001,
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
      });
    },
    noLogin() {
      if (this.login) {
        this.login.close();
        this.login = null;
      }
    },
    async submit(pamt) {
      this.loginOpen('提交中...')
      try {
        if (pamt.pictureFile) {
          
          let ossDis = await this.API.get(this.API.fileurl.getImgToOss, {
            type: "suggestion"
          })
          
          var ossDir = ossDis.data
          let url = await uploadToOss(pamt.pictureFile, ossDir, "name")
          
          pamt.url = url
        }
        let res = await this.API.post(this.API.fileurl.postSuggestSubmit, {
          submitUserId: localStorage.getItem('userId'),
          orgId: localStorage.getItem('orgId'),
          orgName: localStorage.getItem('orgName'),
          userType: localStorage.getItem('userType'),
          name: pamt.name,
          type: pamt.suggestType,
          path: this.$route.path,
          text: pamt.content,
          url: pamt.url || null
        })
        if (res.data.code == 200) {
          this.handleCancel()
          this.$message.success('提交成功')
          
          this.dialogVisible = false
          this.loadMyList()
        }
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.noLogin()
      }
    },
    handleCancel() {
      this.resetFormInner();
    },
    resetFormInner() {
      this.formData = {
        name: "",
        suggestType: "",
        content: ""
      };
      this.pictureFile = null;
	  this.dialogVisible=false
      this.isViewMode = false
      this.dialogTitle = "新增反馈"
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    }
  }
};
</script>
<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
}
.suggest-form-wrap {
  display: flex;
  flex-direction: column;
}
.form-scroll-container {
  max-height: 420px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 0;
}
.form-btn-wrap {
  padding-top: 14px;
  text-align: center;
}
/deep/ .avatar-uploader .el-upload--picture-card {
  width: 100px;
  height: 100px;
  box-sizing: border-box;
}
/deep/ .avatar-uploader.has-file .el-upload--picture-card {
  display: none !important;
}
/deep/ .avatar-uploader .el-upload-list--picture-card {
  box-sizing: border-box;
}
/deep/ .el-table th.is-leaf {
  text-align: center !important;
}
</style>
